/* global GM_STATE */
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { useEffect, useState } from 'preact/hooks'
import { getCartProperties, getDisableChangeQuantity, getMaxQuantity, removeCartItem, updateCart, updateCartItem } from 'libs/cart'

function useCartItem(item, setCart, setIsFetching) {
  const [quantity, setQuantity] = useState(item.quantity)
  const [renderKey, setRenderKey] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const maxQuantity = getMaxQuantity(item)
  const properties = getCartProperties(item.properties)
  const isDisabled = getDisableChangeQuantity(properties)

  const onLoading = (value) => {
    setIsFetching(value)
    setIsLoading(value)
  }

  const refreshCart = async () => {
    const newCart = await updateCart()
    setCart(newCart)
    GM_STATE.cart.initCart = newCart
    globalEmitter.emit(emitterProps.cart.update, newCart.items)
  }

  const onRemove = async () => {
    onLoading(true)
    try {
      await removeCartItem(item.key)
      await refreshCart()
    } catch (error) {
      setRenderKey(renderKey + 1)
    }
    onLoading(false)
  }

  const onChange = async () => {
    onLoading(true)
    try {
      await updateCartItem(item.key, quantity)
      await refreshCart()
    } catch (error) {
      setRenderKey(renderKey + 1)
    }
    onLoading(false)
  }

  const customClassPrice = (() => {
    let classSize = 'text-base'
    if ((item.compare_at_price * item.quantity) > item.line_price || item.original_line_price > item.line_price) {
      const newClassSize = ' text-grey-300'
      classSize += newClassSize
    } else {
      classSize += ' text-grey-700'
    }
    return classSize
  })()

  useEffect(() => {
    setQuantity(item.quantity)
  }, [item])

  useEffect(() => {
    if (item.quantity !== quantity && quantity <= maxQuantity) {
      onChange(quantity)
    }
  }, [quantity])

  return {
    quantity,
    setQuantity,
    isLoading,
    setIsLoading,
    maxQuantity,
    properties,
    isDisabled,
    renderKey,
    onRemove,
    onChange,
    customClassPrice
  }
}

export default useCartItem
